import React, { useContext } from 'react'

import Flag from 'components/Luxkit/Flag'
import { connect } from 'react-redux'
import { getSupportContact } from 'selectors/supportContactSelector'
import config from 'constants/config'
import shouldRenderWhatsApp from 'lib/whatsApp'
import whatsAppIcon from '../../icons/whatsapp.svg'
import ListItem from 'components/Luxkit/List/ListItem'
import LuxuryEscapesSmallLogo from '../../Logo/logos/LuxuryEscapesSmallLogo'
import styled from 'styled-components'
import GeoContext from 'contexts/geoContext'
import { useTranslation } from 'react-i18next'

const LELogo = styled(LuxuryEscapesSmallLogo)`
  fill: ${props => props.theme.palette.neutral.one};
`

interface Props {
  currentContact: App.GeoContacts;
  className?: string;
}

function PhoneNumberMobileMenu({
  currentContact,
  className,
}: Props) {
  const localContact = currentContact.local
  const internationalContact = currentContact.international
  const { t } = useTranslation('common')
  const { currentRegionCode } = useContext(GeoContext)

  return (
    <div className={className}>
      <ListItem
        title={t('Sales & Support')}
        subtitle={localContact.humanReadable}
        startIcon={<Flag countryCode={currentRegionCode} />}
        href={`tel:${localContact.number}`}
        aria-label={t('Sales & Support contact')}
        rel="nofollow"
      />
      <ListItem
        title={t('International Support Centre')}
        startIcon={config.BRAND === 'luxuryescapes' ? <LELogo height={24} width={24} /> : undefined}
        subtitle={internationalContact.humanReadable}
        href={`tel:${internationalContact.number}`}
        aria-label={t('International Support Centre contact')}
        rel="nofollow"
      />
      {shouldRenderWhatsApp(currentRegionCode) &&
        <ListItem
          title="WhatsApp"
          startIcon={<img src={whatsAppIcon} width="24" height="24" alt="WhatsApp"/>}
          href={`https://wa.me/${config.WHATS_APP_NUMBER}`}
          aria-label="Whats App"
          rel="noopener"
          target="_blank"
        />}
    </div>
  )
}

function mapStateToProps(state: App.State) {
  return {
    currentContact: getSupportContact(state),
  }
}

export default connect(mapStateToProps)(PhoneNumberMobileMenu)
